import * as React from "react";
const ArchiveIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="16"
    viewBox="0 0 20 16"
  >
    <path
      id="Path_1447"
      data-name="Path 1447"
      d="M20,0H0V6H2V16H18V6h2ZM4,6H16v8H4ZM18,2V4H2V2ZM13,8H7v2h6Z"
    />
  </svg>
);
export default ArchiveIcon;
